import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HospitalDetail from "../pages/hospital/page";
import HospitalsPage from "../pages/hospitals/page";
import ConsultationPage from "../pages/consultation/page";
import AdminPage from "../pages/admin/page";
import PostsPage from "../pages/posts/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/consultation",
    element: <ConsultationPage />,
  },
  {
    path: "/hospitals",
    element: <HospitalsPage />,
  },
  {
    path: "/hospital/:id",
    element: <HospitalDetail />,
  },
  {
    path: "/posts",
    element: <PostsPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;